
import { EAgentUserStatus } from '../../types/common';
import { IAllUsersParam, IAllUsersResponse } from '../../types/user-center/allUsers';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 用户中心 - 全部用户数据查询
 */
export async function queryAllUsers(param: IAllUsersParam) {
  let data = [] as IAllUsersResponse[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IAllUsersParam;

  try {
    const { code, context, message } = await Http.post<{ data: IAllUsersResponse[]; total: number }>(`${hostUrl}/iam/user/list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IAllUsersResponse[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 用户中心 - 全部用户 - 解封、停用、启用
 */
export async function operatingUserStatus(userId: string, status: EAgentUserStatus) {
  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/iam/user/updateStatus`,
      {
        userId,
        status,
      });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 全部用户 - 重置密码
 */
export async function resetUserPassword(userId: string) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/iam/user/reset-initial-pwd`, { userId });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
